import { ViewModel,View, ObservableArray } from "binder"
import  { InvoicesListView } from "./invoicesList-view"
import { IImportingPart } from "../../ipart";
import { ImportBillFileDownloader } from "../importBillFileDownloader";
import { FileSelectorViewModel } from "uicomponents";
import { downloadFile } from "src/uicomponents/components/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ImportProductViewModel } from "../../importProduct-viewModel";
import { InvoiceAttachmentDownloader } from "../invoiceAttachmentFileDownloader";
import { AttachmentListSelectorViewModel, attachmentViewModel } from "src/arap/attachmentListSelector/attachmentListSelector-viewModel";

export class InvoicesListViewModel extends ViewModel implements IImportingPart{
    constructor(parentViewModel: ImportProductViewModel) {
        super(parentViewModel);

        this.items = ObservableArray.create<item>();
        this.title = 'Invoice';
        this._typedParent = parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new InvoicesListView();
    }
    public getTypeId(): string {
        return "VM-E985B5AA-50AD-40EF-ADFD-3F934FEB3F6F"
    }

    private _typedParent : ImportProductViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    private _processId;
    needsProcessToLoad(): boolean {
        return true;
    }
    
    async load(processId: any): Promise<any> {
        try {
            if(stringIsNullOrEmpty(processId)==false)
                this._processId = processId;
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/ListInvoicesForPurchaseProcess',{
                PurchaseProcessId : this._processId
            });
            this.items.update(...result.Invoices.map((x,i)=>{
                let r = new item(this);
                r.index= i+1;
                r.processId = this._processId;

                r.providerCode = x.CustomerCode;
                r.providerId = x.CustomerId;
                r.providerName = x.CustomerName;

                r.eaiInvoiceId = x.InvoiceEaiBillId;
                r.hasInvoice = stringIsNullOrEmpty(r.eaiInvoiceId) == false;
                r.firstBillId = x.InvoiceBillId;
                r.firstBillCode = x.InvoiceBillNo;
                r.firstBillTime = x.InvoiceTime==null ? null : x.InvoiceTime;
                r.firstFileId = x.InvoiceFileId;
                r.firstFileName = x.InvoiceFileName;

                r.secondBillId = x.ReceiptBillId;
                r.secondBillCode = x.ReceiptBillNo;
                r.secondBillTime = x.ReceiptTime==null ? null : x.ReceiptTime;
                r.secondFileId = x.ReceiptFileId;
                r.secondFileName = x.ReceiptFileName;

                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async saveInvoice(item:item){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/CreateNewPurchaseImportingInvoice',{
                ProviderId : item.providerId,
                PurchaseProcessId : item.processId,
                FileContent : item.firstFileSelector.filecontent,
                FileName : item.firstFileSelector.filename,
                ParentBillId : null,
                DollarConversionRate : item.invoiceData.at(0).at(6),
                Products : item.invoiceData.map(x=>{return {
                    MeasuredProductId : x[0],
                    Amount : x[4],
                    Fee : x[5]
                }})
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.load(null);
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
                this.isLoading = false;
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            this.isLoading = false;
        } finally {
        }
    }

    async saveReceipt(item:item){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/CreateReceiptForInvoice',{
                InvoiceId : item.eaiInvoiceId,
                FileContent : item.secondFileSelector.filecontent,
                FileName : item.secondFileSelector.filename,
                ShallReserve : item.shallReserve,
                Products : item.receiptData.map(x=>{return {
                    MeasuredProductId : x[0],
                    Amount : x[5],
                    CustomBenefit : x[6]
                }})
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess("عملیات موفق","عملیات موفق");
                this.load(null);
            }else{
                this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
                this.isLoading = false;
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning("عملیات نا موفق","عملیات نا موفق");
            this.isLoading = false;
        } finally {
        }
    }

    async showInvoiceDetail(item:item)
    {
        let selectedInvoice = new DetailedInvoice(this);
        selectedInvoice.loadByInvoiceId(item.eaiInvoiceId)
        this._typedParent.showPopup(selectedInvoice);
    }

    async checkInvoiceFile(file):Promise<any>{
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/VerifyExcelFile',{
                ExcelFile : file,
                ProductCodeColumn : 1,
                BrandColumn : 2,
                ShallFillColumns : [1,2,3,4,5],
                NumericColumns : [3,4,5]
            });
            return result;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async checkReceiptFile(file):Promise<any>{
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/ImportProductServices/VerifyExcelFile',{
                ExcelFile : file,
                ProductCodeColumn : 1,
                BrandColumn : 2,
                ShallFillColumns : [1,2,3,4,5],
                NumericColumns : [3,4,5]
            });
            return result;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}


export class item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoicesListViewModel) {
        super(parent);
        this.downloader = new ImportBillFileDownloader();

        this.firstFileSelector = new FileSelectorViewModel(this);
        this.firstFileSelector.onFileChoosed = ()=>this.invoiceFileChanged();
        this.firstFileSelector.downloader = this.downloader;

        this.secondFileSelector = new FileSelectorViewModel(this);
        this.secondFileSelector.onFileChoosed = ()=>this.receiptFileChanged();
        this.secondFileSelector.downloader = this.downloader;
        this.shallReserve = true;
        this._typedParent = parent;
    }

    private _typedParent : InvoicesListViewModel;
    private downloader :ImportBillFileDownloader;
    public set processId(v: string) { this._processId = v; } public get processId(): string { return this._processId;} private _processId: string;
    

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set shallReserve(v: boolean) { this._shallReserve = v; } public get shallReserve(): boolean { return this._shallReserve;} private _shallReserve: boolean;
    public set hasInvoice(v: boolean) { this._hasInvoice = v; } public get hasInvoice(): boolean { return this._hasInvoice;} private _hasInvoice: boolean;
        
    public set providerId(v: string) { this._providerId = v; } public get providerId(): string { return this._providerId;} private _providerId: string;
    public set providerName(v: string) { this._providerName = v; } public get providerName(): string { return this._providerName;} private _providerName: string;
    public set providerCode(v: string) { this._providerCode = v; } public get providerCode(): string { return this._providerCode;} private _providerCode: string;
    public set eaiInvoiceId(v: string) { this._eaiInvoiceId = v; } public get eaiInvoiceId(): string { return this._eaiInvoiceId;} private _eaiInvoiceId: string;
    
    public set firstBillId(v: string) { 
        this._firstBillId = v;
        this.downloader.purchaseBillId = v;
    } public get firstBillId(): string { return this._firstBillId;} private _firstBillId: string;
    public set firstBillCode(v: string) { this._firstBillCode = v; } public get firstBillCode(): string { return this._firstBillCode;} private _firstBillCode: string;
    public set firstBillTime(v: string) { this._firstBillTime = v; } public get firstBillTime(): string { return this._firstBillTime;} private _firstBillTime: string;
    public set firstFileId(v: string) { 
        this._firstFileId = v; 
        this.firstFileSelector.fileid = v;
    } public get firstFileId(): string { return this._firstFileId;} private _firstFileId: string;
    public set firstFileName(v: string) { 
        this._firstFileName = v; 
        this.firstFileSelector.filename = v;
    } public get firstFileName(): string { return this._firstFileName;} private _firstFileName: string;
    public set firstFileSelector(v: FileSelectorViewModel) { this._firstFileSelector = v; } public get firstFileSelector(): FileSelectorViewModel { return this._firstFileSelector;} private _firstFileSelector: FileSelectorViewModel;
    

    public set secondBillId(v: string) { 
        this._secondBillId = v;
        // this.downloader.purchaseBillId = v;
    } public get secondBillId(): string { return this._secondBillId;} private _secondBillId: string;
    public set secondBillCode(v: string) { this._secondBillCode = v; } public get secondBillCode(): string { return this._secondBillCode;} private _secondBillCode: string;
    public set secondBillTime(v: string) { this._secondBillTime = v; } public get secondBillTime(): string { return this._secondBillTime;} private _secondBillTime: string;
    public set secondFileId(v: string) { 
        this._secondFileId = v; 
        this.secondFileSelector.fileid = v;
    } public get secondFileId(): string { return this._secondFileId;} private _secondFileId: string;
    public set secondFileName(v: string) { 
        this._secondFileName = v; 
        this.secondFileSelector.filename = v;
    } public get secondFileName(): string { return this._secondFileName;} private _secondFileName: string;
    public set secondFileSelector(v: FileSelectorViewModel) { this._secondFileSelector = v; } public get secondFileSelector(): FileSelectorViewModel { return this._secondFileSelector;} private _secondFileSelector: FileSelectorViewModel;
    
    public invoiceData:string[][];
    private async invoiceFileChanged(){
        try {
            let result =await this._typedParent.checkInvoiceFile(this.firstFileSelector.filecontent);
            if(result.IsValid){
                this.invoiceData = result.Data;
                this.messageBoxConfirmSuccess("فایل بررسی و صحیح است.","صحت فایل")
            }else{
                downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                this.messageBoxConfirmWarning('ساختار فایل صحیح نیست','خطا در فایل');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ارتباط','خطا در ارتباط');
        } finally {
        }
    }
    async saveInvoice(){
        this._typedParent.saveInvoice(this);
    }


    public receiptData:string[][];
    private async receiptFileChanged(){
        try {
            let result =await this._typedParent.checkReceiptFile(this.secondFileSelector.filecontent);
            if(result.IsValid){
                this.receiptData = result.Data;
                this.messageBoxConfirmSuccess("فایل بررسی و صحیح است.","صحت فایل")
            }else{
                downloadFile(result.InvalidFileInfo,'مشکلات.xlsx');
                this.messageBoxConfirmWarning('ساختار فایل صحیح نیست','خطا در فایل');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در ارتباط','خطا در ارتباط');
        } finally {
        }
    }

    async saveReceipt(){
        this._typedParent.saveReceipt(this);
    }    

    async showInvoiceDetail(){
        this._typedParent.showInvoiceDetail(this);
    }
}

export class DetailedInvoice extends ViewModel implements IPopup{
    
    public getTypeId(): string {return 'detailInvoice';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InvoicesListViewModel) {
        super(parent);
        this.attachments = new AttachmentListSelectorViewModel(this);
    }
    closePopup() {}

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description;} private _description: string;
    public set containerNo(v: string) { this._containerNo = v; } public get containerNo(): string { return this._containerNo;} private _containerNo: string;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;

    async setInvoiceDetail(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/SetPurchaseInfo',{
                InvoiceId:this.id,
                Description:this.description,
                ContainerNo:this.containerNo,
                Attachments:this.attachments.getAttachments().map(x=>{
                    return {
                        Id:x.id,
                        Name:x.name,
                        Content:x.content
                    };
                })
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('جزئیات فاکتور با موفقیت ثبت شد','جزئیات فاکتور');
                this.closePopup();
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }    
    
    async loadByInvoiceId(id: string) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/GetPurchaseInfo',{
                InvoiceId:id
            });
            this.id = id;
            this.containerNo = result.ContainerNo;
            this.description = result.Description;
            this.attachments.attachments.update(...result.Attachments.map(x=>{
                let attachment = new attachmentViewModel(this.attachments);
                attachment.fileSelector.downloader = new InvoiceAttachmentDownloader();
                attachment.fileSelector.maxsize = 1000;
                attachment.fileSelector.fileid = x.Id;
                attachment.fileSelector.filename = x.Name;
                return attachment;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }   
    }
}
